import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { vehicleGroupSchema } from '../schemas/vehicle-group.schema';

/**
 * Returns a specific Vehicle Group
 * @param vehicleGroupId The ID of the Vehicle Group being requested
 * @returns The Vehicle Group
 */
export function getVehicleGroupsId(this: unknown, vehicleGroupId: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).vehicleGroupsUrl}/${vehicleGroupId}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(vehicleGroupSchema));
}
